import { useQuery } from '@tanstack/react-query';
import { DISCIPLINES_LIBRARY_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { useMemo } from 'react';

export const useQueryDisciplineLibraries = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [DISCIPLINES_LIBRARY_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const response = await ObrasApiV2.listDisciplineLibraries();
      return response.data.data;
    },
    enabled: true
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
